import { useContext } from 'react'

import { MetadataContext } from '@Globals/Metadata'

export const DEFAULT_LOCALE = 'en-GB'

/**
 * The locale of the store serving this request. This is the value `useRouter().locale` used to carry (the proxy
 * derives the URL locale from the same store field), without depending on the pages router.
 */
export const useLocale = (): string => {
  const { store } = useContext(MetadataContext)
  return store?.config?.localeCode || DEFAULT_LOCALE
}
